export var SDK_VERSION = '6.15.0';
//# sourceMappingURL=version.js.map